import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the coursesMobile state domain
 */

const selectCoursesMobileDomain = state => state.coursesMobile || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectCoursesMobileDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectCoursesMobileDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectCoursesMobileDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectCoursesMobileDomain,
    substate => substate.firstRender,
  );

const makeSelectItemsList = () =>
  createSelector(
    selectCoursesMobileDomain,
    substate => substate.itemsList,
  );
const makeSelectAppointments = () =>
  createSelector(
    selectCoursesMobileDomain,
    substate => substate.appointments,
  );


const makeSelectCourse = () =>
  createSelector(
    selectCoursesMobileDomain,
    substate => substate.courseDetail,
  );

/**
 * Default selector used by Courses
 */

const makeSelectCoursesMobile = () =>
  createSelector(
    selectCoursesMobileDomain,
    substate => substate,
  );

export default makeSelectCoursesMobile;
export {
  selectCoursesMobileDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemsList,
  makeSelectAppointments,
  makeSelectCourse,
};
